export default __webpack_public_path__ + "static/media/my-patient.4ced64e0.svg";